var exports = {
  "nf": "x31de4314--010d76--link",
  "VA": "x31de4314--010d76--subtitle",
  "Op": "x31de4314--010d76--availability",
};

module.exports = exports;
